import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import dotProductCommons from './commons/dot_product.js'

const level = new Level({
    name: 'dot_product_formula',
    dependencies: [
        'levels_maths/vector'
    ]
})


function common (q, params) {

    let vectors = dotProductCommons.vectors(params)
    dotProductCommons.displayCoords(q, vectors)
    dotProductCommons.question(q, vectors)

}


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(1, 7, {name: 'ux'}) * 100,
            uY: 1,
            vX: 1,
            vY: random.fairChoiceInt(2, 23, {name: 'vy'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(1, 7, {name: 'ux'}) * 100,
            uY: 2,
            vX: 1,
            vY: random.fairChoiceInt(1, 10, {name: 'vy'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(1, 3, {name: 'ux'}) * 100,
            uY: 1,
            vX: 3,
            vY: random.fairChoiceInt(1, 25, {name: 'vy'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(1, 4, {name: 'ux'}) * 100,
            uY: 2,
            vX: 3,
            vY: random.fairChoiceInt(1, 5, {name: 'vy'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(1, 5, {name: 'ux'}),
            uY: random.fairChoiceInt(1, 4, {name: 'uy'}) * 100,
            vX: 2,
            vY: 3
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(1, 3, {name: 'ux'}),
            uY: random.fairChoiceInt(1, 4, {name: 'uy'}),
            vX: random.fairChoiceInt(1, 4, {name: 'vx'}),
            vY: random.fairChoiceInt(1, 3, {name: 'vy'})
        })
    }
})



level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 0,
            uY: random.fairChoiceInt(1, 4,  {name: 'uy'}),
            vX: random.fairChoiceInt(1, 12, {name: 'vx'}),
            vY: random.fairChoiceInt(1, 3,  {name: 'vy'})
        })
    }
})



level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(1, 3,  {name: 'ux'}),
            uY: random.fairChoiceInt(1, 23, {name: 'uy'}),
            vX: random.fairChoiceInt(1, 4,  {name: 'vx'}),
            vY: 0
        })
    }
})



level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: random.fairChoiceInt(-3, 0,  {name: 'ux'}),
            uY: random.fairChoiceInt(-3, -1, {name: 'uy'}),
            vX: random.fairChoiceInt(1, 4,   {name: 'vx'}),
            vY: random.fairChoiceInt(1, 3,   {name: 'vy'})
        })
    }
})




export default level

